module.exports = __webpack_public_path__ + "img/gy.b199c94b.png";